import React from 'react';
import { Link } from 'react-router-dom';
import { ClipboardPlus, ClipboardCheck, Check, ArrowRight } from 'lucide-react';
import { useQuoteList } from '../../lib/quoteList';
import { trackEvent } from '../../lib/analytics';

export const ChatPartActions = ({ parts, onNavigate }) => {
  const { list, toggle } = useQuoteList();
  const added = parts.filter((p) => list[p.pn]);
  const add = (pn) => { trackEvent('part_quote_click', { product: 'UL101', part: pn, resource: 'charlie-echo' }); toggle(pn); };

  if (parts.length > 4) {
    return (
      <Link to="/products/ul101#kit-parts" onClick={onNavigate} className="ml-10 inline-flex items-center gap-2 rounded-full border border-orange-300 bg-orange-50 px-3 py-1.5 text-xs font-semibold text-orange-700 hover:bg-orange-100 transition-colors" data-testid="charlie-kit-check-link">
        <ClipboardCheck className="h-3.5 w-3.5" /> Tick off your kit with the completeness checklist <ArrowRight className="h-3.5 w-3.5" />
      </Link>
    );
  }
  return (
    <div className="ml-10 rounded-2xl border border-slate-200 bg-white p-3 shadow-sm" data-testid="charlie-part-actions">
      <p className="mb-2 text-[11px] font-semibold uppercase tracking-wide text-slate-500">Replacement parts</p>
      <div className="flex flex-wrap gap-1.5">
        {parts.map((p) => {
          const on = !!list[p.pn];
          return (
            <button key={p.pn} type="button" onClick={() => add(p.pn)} aria-pressed={on}
              className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 text-xs font-semibold transition-colors ${on ? 'bg-[#1e2d3b] text-white hover:bg-slate-700' : 'bg-orange-500 text-white hover:bg-orange-600'}`}
              data-testid={`charlie-add-part-${p.pn}`}>
              {on ? <Check className="h-3.5 w-3.5" /> : <ClipboardPlus className="h-3.5 w-3.5" />}
              <span className="font-mono">{p.pn}</span> · {p.name}{on ? ' — in quote list' : ''}
            </button>
          );
        })}
      </div>
      {added.length > 0 && (
        <Link to="/products/ul101#kit-parts" onClick={onNavigate} className="mt-2 inline-flex items-center gap-1 text-xs font-semibold text-blue-700 hover:text-orange-600 transition-colors" data-testid="charlie-view-quote-list">
          Review quote list &amp; send one request <ArrowRight className="h-3.5 w-3.5" />
        </Link>
      )}
    </div>
  );
};
